import { Injectable } from '@angular/core';
import { DbEntityProvider } from './db-entity.provider';
import { DbDaoService, GetAllDataOptions } from '../db/db-dao.service';
import { UPDATES_TYPES } from '@shared/constants/updates-types.const';
import { PaymentMethod } from '@shared/classes/payment-method.class';
import { Observable } from 'rxjs';
import { Query } from '@paymash/capacitor-database-plugin';
import { PAYMENT_METHOD_NAMES } from '@shared/constants';
import { map } from 'rxjs/operators';

@Injectable()
export class PaymentMethodsDbEntityProvider extends DbEntityProvider {
  constructor(dbDaoService: DbDaoService) {
    super(UPDATES_TYPES.PaymentMethod.type, dbDaoService);
  }

  getByUuid(uuid: string): Observable<PaymentMethod> {
    return <Observable<PaymentMethod>>this.getEntityByUuid(uuid);
  }

  getList(): Observable<PaymentMethod[]> {
    return <Observable<PaymentMethod[]>>this.getEntitiesList();
  }

  getMethodByName(name: PAYMENT_METHOD_NAMES): Observable<PaymentMethod> {
    return this.getList().pipe(map((items: PaymentMethod[]) => items?.find((element: PaymentMethod) => element.name === name)));
  }

  getListByParams(queryParams: Query, options?: GetAllDataOptions): Observable<PaymentMethod[]> {
    return <Observable<PaymentMethod[]>>this.getEntitiesListByParams(queryParams, options).pipe(this.mapPipeTransformEntities());
  }
}
